// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mask-skew[data-v-241ffd4a]{transform:skewY(-15deg)}.art-skew[data-v-241ffd4a]{transform:skewY(15deg);position:relative;top:-15%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
